export const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api";
export const APP_VERSION = process.env.REACT_APP_VERSION || "v.dev";